import { render } from "./CIS-Content-Carousel.vue?vue&type=template&id=33428050"
import script from "./CIS-Content-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Carousel.vue?vue&type=script&lang=js"

import "./CIS-Content-Carousel.vue?vue&type=style&index=0&id=33428050&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__